import * as shortid from 'shortid'

export interface IChild {
    childId: string;
    fullName: string;
    birthDate?: any;
    age?: number;
    sex: string;
    eyeColor: string;
    hairColor: string;
    height: string;
    heightUnit: string;
    weight: string;
    weightUnit: string;
    images?: string[];
}

export const initialChild: IChild =
{
    childId: shortid.generate(),
    fullName: "",
    sex: "",
    eyeColor: "",
    hairColor: "",
    height: "",
    heightUnit: "",
    weight: "",
    weightUnit: "",
    images: [],
}


// WEBPACK FOOTER //
// ./src/share/types/case/children.ts